import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fadeInUp, staggerContainer } from "@/lib/constants";

export const SEOAnalistaSection = () => {
  return (
    <section className="relative section-padding" data-testid="seo-analista-section">
      <div className="max-w-4xl mx-auto relative z-10">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={staggerContainer}
        >
          <motion.div variants={fadeInUp}>
            <h2 className="text-3xl sm:text-4xl font-bold mb-8">
              Analista de datos para empresas en Murcia
            </h2>

            <div className="text-slate-400 text-base leading-relaxed space-y-6">
              <p>
                Soy analista de datos y ayudo a empresas a entender qué está pasando realmente en su negocio y, sobre todo, dónde están perdiendo dinero sin darse cuenta.
              </p>

              <p>
                Trabajo con datos de ventas, costes, stock y operaciones. Cojo toda esa información que normalmente está repartida en Excel, ERP o diferentes herramientas, la organizo y la convierto en algo útil: decisiones claras que impactan directamente en los resultados.
              </p>

              <p>
                Muchas empresas tienen datos, pero no los están usando bien. No saben qué productos les dejan margen de verdad, qué clientes son realmente rentables o qué parte del negocio está generando pérdidas. Y mientras tanto, siguen tomando decisiones con intuición o con información incompleta.
              </p>

              <p>
                Ahí es donde entro yo.
              </p>

              <p>
                Mi trabajo no es hacer dashboards bonitos ni informes interminables. Es ayudarte a ver lo que no estás viendo y decirte exactamente qué hacer para mejorar tus números. Sin rodeos, sin palabras de moda y sin complicarlo innecesariamente.
              </p>

              <p>
                He trabajado con empresas de distintos sectores como industria, distribución y agroalimentario, donde pequeños cambios basados en datos pueden suponer una diferencia enorme en beneficios, costes o eficiencia operativa.
              </p>

              <h3 className="text-xl font-bold text-white mt-8 mb-4">
                Ejemplos de lo que puedo detectar en tu empresa
              </h3>

              <p>
                Productos que parecen rentables pero en realidad generan pérdidas por costes ocultos. Clientes que compran mucho pero dejan poco margen. Ineficiencias en procesos que están afectando directamente a la rentabilidad. Necesidades de stock mal planificadas que provocan roturas o exceso de inventario.
              </p>

              <p>
                Todo esto no se consigue con intuición. Se consigue con datos bien analizados.
              </p>

              <p>
                Si tienes la sensación de que tu empresa podría estar funcionando mejor, pero no sabes exactamente dónde está el problema, probablemente los datos ya tienen la respuesta. Solo hay que saber leerlos.
              </p>

              <p>
                Trabajo con empresas en Murcia y en toda España, ayudándoles a transformar sus datos en decisiones más inteligentes, más rápidas y, sobre todo, más rentables. Si quieres saber más sobre cómo trabajo, puedes ver los <Link to="/servicios" className="text-indigo-400 hover:text-indigo-300 underline underline-offset-2">servicios que ofrezco</Link> o leer nuestro <Link to="/blog" className="text-indigo-400 hover:text-indigo-300 underline underline-offset-2">blog sobre análisis de datos</Link>.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
